'use client'

import cn from 'clsx'

import { Copy } from 'shared-components'

import { type Contact as ContactType } from '../../../../../apps/benmax/src/types/sanity.types'

type ExtendedContactType = ContactType & {
    site: string
    siteSettings: any
}

import Locations from './Locations'
import Form from './Form'

import s from './Contact.module.sass'

function Contact({ title, copy, formTitle, formsparkId, formFields, formCopy, siteSettings }: ExtendedContactType) {
    return (
        <section className={s.Contact}>
            <div className={cn(s.Cont, 'container')}>
                <div className={s.Main}>
                    {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
                    {copy && (
                        <div className={s.Copy}>
                            <Copy copy={copy} />
                        </div>
                    )}
                    {siteSettings?.footerOffices?.offices && (
                        <Locations locations={siteSettings?.footerOffices?.offices} />
                    )}
                </div>
                <Form formTitle={formTitle} formsparkId={formsparkId} formFields={formFields} formCopy={formCopy} />
            </div>
        </section>
    )
}

export default Contact
